export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indisponible"])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas encore analysé"])}
      },
      "en": {
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unavailable"])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not analyzed yet"])}
      }
    }
  })
}
